export default __webpack_public_path__ + "static/media/16-Bit_LE.cad5715a.jpg";